import $ from 'jquery'
import getMessage      from '../messages/getMessage'
import { showLoading } from '../render/loading'
import { render }      from '../render/message'

let $panel,
    $bubble,
    $close,
    $content,
    $reset,
    $wrap,
    first_q

/**
 * Initialize the panels
 */
const init = () => {

  $panel   = $( '.your-chat__panel' )  .first(),
  $bubble  = $( '.your-chat__bubble' ) .first(),
  $close   = $panel                    .find( '.close' ),
  $content = $panel                    .find( '.chat-content' ),
  $reset   = $panel                    .find( '.reset' ),
  $wrap    = $content                  .find( '.wrap' ),
  first_q  = $panel                    .attr( 'init_q' )

  $close.click( () => {
    $panel  .removeClass( 'activated' )
    $bubble .removeClass( 'activated' )
  } )

  $reset.click( () => {
    $wrap.html( '' )
    getMessage( first_q )
  } )

  let disableClicks = false;
  let disableClicksTimeout;

  $panel.on('click', 'a', ( e ) => {
    disableClicks = true;
    disableClicksTimeout = setTimeout(function(){
      disableClicks = false;
    },100);
  });

  $panel.click( e => {
    if( disableClicks === true ) return;
    let $option = $( e.target ).closest( '[msg_id]' )
    if ( $option )
      applyOption( $option )
  } );

  setSize()
  $( window ).on( 'resize', setSize )

  setTimeout( () => getMessage( first_q ), 20 )
}

/**
 * Set the panel size
 */
const setSize = () => {

    const panelHeight = $panel.height()

    $content.css( { 'max-height' : panelHeight } )

}


/**
 * Removes the options wrap, renders the user text and fetches the linked
 * message when an option is clicked
 *
 * @param object
 * @return void
 */
const applyOption = $option => {
  const $parent = $option.closest( '.options' ),
        id      = $option.attr( 'msg_id' ),
        text    = $option.html()

  if ( id && text ) {
    showLoading()
    $parent.remove()
    render( {
      type    : 'Answer',
      options : [],
      text    : text,
      user    : 'user',
      id      : id
    } )
    getMessage( id )
  }
}

export default () => init()
